import BaseModel from "nexia_mobile/models/base_model";
import Dispatch from "nexia_mobile/flux_like/dispatch";
import followLink from "nexia_mobile/models/followLink";
import { getLanguageSet, template } from "nx-components/Locales";

export default class Setting extends BaseModel {
  static isEphemeral = true;

  parse(passedAttrs, ...args) {
    let attrs = super.parse(...[passedAttrs, ...args]);

    if (attrs.current_value != null) {
      attrs.value = attrs.current_value;
      delete attrs.current_value;
    }

    return attrs;
  }

  getName() {
    return this.get("title");
  }

  getValueName(forValue = null) {
    let values = this.get("values");
    let valueIndex = _(values || []).indexOf(
      forValue == null ? this.get("value") : forValue
    );
    return this.get("labels")[valueIndex];
  }

  isBoolean() {
    return this.get("values")[0] === true && this.get("values")[1] === false;
  }

  getDescriptionsForChange(newValue) {
    const language = getLanguageSet().nexia_mobile.models.setting;
    let label = this.getValueName(newValue);
    // should really select setting values using an index to avoid this nonsense...
    if (label == null) {
      label = this.getValueName(parseFloat(newValue));
    }
    const title = this.get("title");
    return {
      past: template(language.descriptionPastTemplate, { title, label }),
      presentParticiple: template(language.descriptionPresentTemplate, {
        title,
        label,
      }),
      failure: template(language.descriptionFailureTemplate, { title, label }),
    };
  }

  saveValue(newValue, parentDevice, ids = null) {
    Dispatch("DISABLE_LOCATION_POLLING");
    const link = {
      href: this.url(),
      method: "POST",
    };
    const oldValue = this.get("value");
    this.set("value", newValue); // Set value optimistically so the UI shows the requested value during the fetch
    if (ids) {
      this.set("hasGroupSaveChanges", true);
    }
    return followLink(this, link, {
      // This used to send form-encoded data (because of jQuery) so the controllers expect strings from all settings
      // TODO: change the relevant controllers in some backwards compatible way to be more flexible
      data: { value: newValue.toString(), ids },
      maxRequestsCount: 30,
    })
      .then(
        () => parentDevice.fetch(),
        () => {
          this.set("value", oldValue);
        }
      )
      .then(() => {
        Dispatch("ENABLE_LOCATION_POLLING");
        Dispatch(
          "DEMO_MODE_EVENT",
          parentDevice,
          this.getDescriptionsForChange(newValue).past
        );
      })
      .catch(() => Dispatch("ENABLE_LOCATION_POLLING"))
      .then(() => {
        if (this.get("value") !== newValue) {
          throw new Error(this.getDescriptionsForChange(newValue).failure);
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/models/setting.js